import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "01804719-007e-44ba-8505-0957a56d3ec9"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter01804719007e44ba85050957a56d3ec9(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter01804719007e44ba85050957a56d3ec9 footer`}>
      {props["links"] || <Navigation className="LinksBf1001d9881a45ccBd5fA19a87e36371" parentTag={buildClassName("LinksBf1001d9881a45ccBd5fA19a87e36371", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo0ec06514296a4b1e8fe519d906bffcce" parentTag={buildClassName("Logo0ec06514296a4b1e8fe519d906bffcce", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright6e4a78bc970f4cf9Be957119fc78e814" parentTag={buildClassName("Copyright6e4a78bc970f4cf9Be957119fc78e814", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow0b0d6bbb5ea547e984ee712a40fa6b28" parentTag={buildClassName("Groupflow0b0d6bbb5ea547e984ee712a40fa6b28", parentTag)} {...props} />}
    </footer>
  );
}

// id: "0ec06514-296a-4b1e-8fe5-19d906bffcce"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "01804719-007e-44ba-8505-0957a56d3ec9"
export function Logo0ec06514296a4b1e8fe519d906bffcce(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo0ec06514296a4b1e8fe519d906bffcce" parentTag={buildClassName("Logo0ec06514296a4b1e8fe519d906bffcce", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "6e4a78bc-970f-4cf9-be95-7119fc78e814"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "01804719-007e-44ba-8505-0957a56d3ec9"
export function Copyright6e4a78bc970f4cf9Be957119fc78e814(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright6e4a78bc970f4cf9Be957119fc78e814" parentTag={buildClassName("Copyright6e4a78bc970f4cf9Be957119fc78e814", parentTag)} {...props} />
  );
}

// id: "bf1001d9-881a-45cc-bd5f-a19a87e36371"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "01804719-007e-44ba-8505-0957a56d3ec9"
export function LinksBf1001d9881a45ccBd5fA19a87e36371(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksBf1001d9881a45ccBd5fA19a87e36371" parentTag={buildClassName("LinksBf1001d9881a45ccBd5fA19a87e36371", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "0b0d6bbb-5ea5-47e9-84ee-712a40fa6b28"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "01804719-007e-44ba-8505-0957a56d3ec9"
export function Groupflow0b0d6bbb5ea547e984ee712a40fa6b28(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow0b0d6bbb5ea547e984ee712a40fa6b28" parentTag={buildClassName("Groupflow0b0d6bbb5ea547e984ee712a40fa6b28", parentTag)} {...props} />
  );
}

// id: "2d0b8ad9-03eb-4747-923b-23251b8169dc"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "0ec06514-296a-4b1e-8fe5-19d906bffcce"
export const LogoType2d0b8ad903eb4747923b23251b8169dc = "FOOTER";

// id: "87145457-bde2-4e61-8590-c5a9dd9f8904"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "bf1001d9-881a-45cc-bd5f-a19a87e36371"
export const NavMenuSlug87145457Bde24e618590C5a9dd9f8904 = "footer-nav";

// id: "4b7ff30f-a2fa-4d71-afda-f72d9681ab2b"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "0ec06514-296a-4b1e-8fe5-19d906bffcce"
export const ContentSlug4b7ff30fA2fa4d71AfdaF72d9681ab2b = "footer-logo";

const Components = {
  DefaultFooter01804719007e44ba85050957a56d3ec9,
  Logo0ec06514296a4b1e8fe519d906bffcce,
  Copyright6e4a78bc970f4cf9Be957119fc78e814,
  LinksBf1001d9881a45ccBd5fA19a87e36371,
  Groupflow0b0d6bbb5ea547e984ee712a40fa6b28,
  LogoType2d0b8ad903eb4747923b23251b8169dc,
  NavMenuSlug87145457Bde24e618590C5a9dd9f8904,
  ContentSlug4b7ff30fA2fa4d71AfdaF72d9681ab2b
}

export default Components;